<template>
  <router-view/>
</template>

<style lang="stylus">
main-color  #444444
light-bg-color linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%)
#app
  font-family "Times New Roman" , "游明朝" , "Yu Mincho" , "游明朝体" , "YuMincho" , "ヒラギノ明朝 Pro W3" , "Hiragino Mincho Pro" , "HiraMinProN-W3" , "HGS明朝E" , "ＭＳ Ｐ明朝" , "MS PMincho" , serif;
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #444444
</style>
